<template>
    <div class="lds-ring loader-basic-spinner"><div></div><div></div><div></div><div></div></div>
</template>

<script>
    export default {
        name: "BasicSpinner"
    }
</script>

<style scoped>
    /* Spinner */
    .lds-ring {
        display: inline-block;
        position: relative;
        width: 32px;
        height: 32px;
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 30px;
        height: 30px;
        margin: 6px;
        border: 6px solid #fff;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #fff transparent transparent transparent;
    }

    /* Alternate rendering */
    .lds-ring.blue div {
        border: 6px solid #3086e2;
        border-color: #3086e2 transparent transparent transparent;
    }
    .lds-ring.large {
        width: 64px;
        height: 64px;
    }
    .lds-ring.large div {
        width: 51px;
        height: 51px;
    }

    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>